import { useState } from 'react';

export const useFileUpload = () => {
  const [isDragging, setIsDragging] = useState(false);
  const [dragDepth, setDragDepth] = useState(0);

  const validateFile = (file) => {

    const maxSize = 2 * 1024 * 1024;
    if (file.size > maxSize) {
      const errorMsg = `File size exceeds 2 MB.`;
      return {
        valid: false,
        error: `Error: ${errorMsg}`
      };
    }

    return { valid: true };
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    setDragDepth(0);
    return e.dataTransfer.files;
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragDepth(prev => prev + 1);
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragDepth(prev => prev - 1);
    if (dragDepth - 1 === 0) {
      setIsDragging(false);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = 'copy';
  };

  return {
    isDragging,
    validateFile,
    handleDrop,
    handleDragEnter,
    handleDragLeave,
    handleDragOver,
  };
};